// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/search-coza/search-coza.component.scss
// module id = 1000
// module chunks = 0